module.exports = __webpack_public_path__ + "img/联系我们banner.ff023827.png";